<div class="prs-auth-modal-panel prs-impersonation-modal" data-testing-id="csr-impersonation-select-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-csr-view-as-title">{{ 'impersonation.view_as.modal_title' | translate }}</h2>
    <button
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      [disabled]="selecting"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <ng-container *ngIf="!pendingUser; else confirmStep">
      <p class="text-muted mb-3">{{ 'impersonation.view_as.modal_hint' | translate }}</p>

      <label class="form-label" for="prs-csr-cobrowse-query">{{
        'impersonation.view_as.search_label' | translate
      }}</label>
      <!-- autocomplete=off is ignored by Safari when it thinks the field is a login username;
           decoy credential fields + non-login naming keep iCloud Password AutoFill away. -->
      <form
        class="prs-impersonation-modal__search-form"
        autocomplete="off"
        (submit)="$event.preventDefault(); runSearch()"
      >
        <div class="prs-autofill-decoy" aria-hidden="true">
          <input type="text" name="username" tabindex="-1" autocomplete="username" />
          <input type="password" name="password" tabindex="-1" autocomplete="current-password" />
        </div>
        <div class="prs-impersonation-modal__search-row">
          <input
            #searchInput
            id="prs-csr-cobrowse-query"
            name="prsCobrowseQuery"
            type="text"
            inputmode="search"
            class="form-control prs-impersonation-modal__search-input"
            role="searchbox"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            data-lpignore="true"
            data-1p-ignore="true"
            data-bwignore="true"
            data-form-type="other"
            data-testing-id="csr-impersonation-search"
            [attr.placeholder]="'impersonation.view_as.search_placeholder' | translate"
            [attr.aria-controls]="'prs-csr-view-as-results'"
            [disabled]="selecting || searching"
            [ngModel]="query"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onQueryChange($event)"
          />
          <button
            type="submit"
            class="btn btn-primary prs-impersonation-modal__search-submit"
            data-testing-id="csr-impersonation-search-submit"
            [disabled]="selecting || searching || !(query || '').trim()"
          >
            {{ 'impersonation.view_as.search_button' | translate }}
          </button>
        </div>
      </form>

      <p *ngIf="searching" class="prs-impersonation-modal__status small text-muted mt-2 mb-0" aria-live="polite">
        {{ 'impersonation.view_as.searching' | translate }}
      </p>
      <p
        *ngIf="!searching && hasSearched && !results.length"
        class="prs-impersonation-modal__status small text-muted mt-2 mb-0"
        aria-live="polite"
        data-testing-id="csr-impersonation-empty"
      >
        {{ 'impersonation.view_as.no_results' | translate }}
      </p>
      <p
        *ngIf="!searching && hasSearched && results.length >= resultLimit"
        class="prs-impersonation-modal__status small text-muted mt-2 mb-0"
      >
        {{ 'impersonation.view_as.results_capped' | translate: { '0': resultLimit } }}
      </p>

      <ul
        *ngIf="hasSearched && results.length"
        id="prs-csr-view-as-results"
        class="prs-impersonation-modal__results list-unstyled mb-0"
        role="listbox"
        [attr.aria-label]="'impersonation.view_as.results_aria' | translate"
        data-testing-id="csr-impersonation-results"
      >
        <li *ngFor="let user of results" role="option">
          <button
            type="button"
            class="prs-impersonation-modal__result"
            [disabled]="selecting"
            [attr.data-testing-id]="'csr-impersonation-user-' + user.username"
            (click)="requestConfirm(user)"
          >
            <span class="prs-impersonation-modal__result-name">{{ user.displayName }}</span>
            <span class="prs-impersonation-modal__result-meta">
              <span class="prs-impersonation-modal__result-username">{{ user.username }}</span>
              <span class="prs-impersonation-modal__result-email">{{ user.email }}</span>
            </span>
          </button>
        </li>
      </ul>
    </ng-container>

    <ng-template #confirmStep>
      <p class="mb-2" data-testing-id="csr-impersonation-confirm-prompt">
        {{ 'impersonation.view_as.confirm_prompt' | translate: { '0': pendingUser.displayName } }}
      </p>
      <div class="prs-impersonation-modal__confirm-user mb-3">
        <div class="prs-impersonation-modal__result-name">{{ pendingUser.displayName }}</div>
        <div class="prs-impersonation-modal__result-meta">
          <span class="prs-impersonation-modal__result-username">{{ pendingUser.username }}</span>
          <span class="prs-impersonation-modal__result-email">{{ pendingUser.email }}</span>
        </div>
      </div>
      <p class="text-muted small mb-0">{{ 'impersonation.view_as.confirm_note' | translate }}</p>
    </ng-template>
  </div>

  <div *ngIf="pendingUser" class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      data-testing-id="csr-impersonation-confirm-cancel"
      [disabled]="selecting"
      (click)="cancelConfirm()"
    >
      {{ 'impersonation.view_as.confirm_cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-testing-id="csr-impersonation-confirm-submit"
      [disabled]="selecting"
      (click)="confirmCoBrowse()"
    >
      {{ 'impersonation.view_as.confirm_submit' | translate }}
    </button>
  </div>
</div>
